import React, { ReactElement, useEffect } from 'react';
import { RoutedContent } from 'routes';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Layout from 'layout';
import { useStoreRehydrated } from 'easy-peasy';
// import { checkSupport, requestNotificationPermission } from 'utils';

import 'react-toastify/dist/ReactToastify.css';
import SplashScreenProvider from 'components/SplashScreen/SplashScreen';
import { UserProvider } from 'store/userContext';
import { DeadlineProvider } from 'store/deadlineContext';
import { useKeycloak } from './utils/keycloakProvider';

const App = (): ReactElement => {
  const isRehydrated = useStoreRehydrated();

  const { initialized, keycloak } = useKeycloak();

  /* useEffect(() => {
    if (!checkSupport()) return;
    requestNotificationPermission();
  }, []); */

  /* if (initialized && keycloak.authenticated) {
    keycloak.updateToken(305);
  } */

  /* keycloak.onTokenExpired = () => {
    keycloak.updateToken(4);
  }; */

  return (
    <>
      {initialized ? (
        <>
          <UserProvider>
            <DeadlineProvider>
              <ToastContainer />
              <BrowserRouter>
                <Layout>
                  <>
                    <RoutedContent />
                  </>
                </Layout>
              </BrowserRouter>
            </DeadlineProvider>
          </UserProvider>
        </>
      ) : (
        <SplashScreenProvider />
      )}
    </>
  );
};

export default App;
